import React, { useState } from 'react'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import './index.css'

const CustomCalendar = ({ bookingsData = [] }) => {
	const [selectedDate, setSelectedDate] = useState(new Date())

	// Function to normalize date format to match API format
	const formatDateForComparison = (date) => {
		// Ensure we're dealing with local time, not UTC
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	}

	const tileClassName = ({ date, view }) => {
		if (view === 'month') {
			const dateStr = formatDateForComparison(date);
			const booking = bookingsData.find((item) => item.date === dateStr);

			if (booking) {
				return 'highlight flex flex-col justfy-center items-center';
			} else if (date.toDateString() === new Date().toDateString()) {
				return 'today';
			}
		}
	}

	const tileContent = ({ date, view }) => {
		if (view === 'month') {
			const dateStr = formatDateForComparison(date);
			const booking = bookingsData.find((item) => item.date === dateStr);

			if (booking) {
				return <div className='text-nowrap text-[10px]'>{booking?.order_count} orders</div>;
			}
		}
	}

	const onChange = (date) => {
		setSelectedDate(date);
	}

	return (
		<div className="calendar-container">
			<Calendar
				onChange={onChange}
				value={selectedDate}
				tileClassName={tileClassName}
				tileContent={tileContent}
			/>
		</div>
	)
}

export default CustomCalendar